import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getData, imgUrl } from '../Services/api';
import Pagination from '../Services/Pagination';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom";

const AllCallLog = () => {
  const [calls, setCalls] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [filters, setFilters] = useState({
    customerId: '',
    managerId: '',
    type: '',
    dateFrom: '',
    dateTo: ''
  });



  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const manager = params.get("manager");
  const from = params.get("from");
  const to = params.get("to");
  const type = params.get("type");
  console.log("Manager", manager)



  const downloadCallLogsExcel = async () => {
    setExportLoading(true);
    try {
      const query = new URLSearchParams({
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        customerId: filters.customerId,
      }).toString();

      const res = await axios.get(
        `${imgUrl}/api/v1/calls/export?${query}`,
        {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      saveAs(blob, 'call_logs.xlsx');
    } catch (err) {
      console.error('Error downloading call logs Excel:', err);
    } finally {
      setExportLoading(false); // ✅ stop loader
    }
  };

  const fetchCalls = async (pageNumber = page, searchQuery = search) => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page: pageNumber,
        ...filters
      }).toString();

      const res = await getData(
        `/calls?${query}`
      );

      if (res.success) {
        setCalls(res.calls || []);
        setPage(res.currentPage || 1);
        setPages(res.totalPages || 0);
        setTotal(res.totalRecords || 0);
      }
    } catch (error) {
      console.log('Error fetching calls:', error);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };

  useEffect(() => {
    fetchCalls();
  }, [page, search, filters]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      fetchCalls(pageNumber);
    }
  };


  useEffect(() => {
    if (manager || from || to) {
      setFilters((prev) => ({
        ...prev,
        managerId: manager || '',
        dateFrom: from || '',
        dateTo: to || '',
        type: type || ''
      }));
    }
  }, [manager, from, to, type]);


  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Call Log
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <div className="page-header-title">
                  <h2 className="mb-0">Call Log</h2>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Filters */}
        <div className="row mb-3 px-4">

          <div className="col-md-3">
            <input
              type="date"
              className="form-control"
              value={filters.dateFrom}
              onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
            />
          </div>
          <div className="col-md-3">
            <input
              type="date"
              className="form-control"
              value={filters.dateTo}
              onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
            />
          </div>

          <div className="col-md-3">
            <button
              className="btn btn-success"
              onClick={downloadCallLogsExcel}
              disabled={exportLoading}
            >
              {exportLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Exporting...
                </>
              ) : (
                "Export Call Logs"
              )}
            </button>
          </div>
        </div>


        {/* Table */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card table-card">
              <div className="card-body">
                <div className="d-sm-flex align-items-center p-4">
                  <ul className="list-inline me-auto my-1">
                    <li className="list-inline-item">
                      <div className="form-search">
                        {/* <i className="fas fa-search" /> */}
                        {/* <input
                          type="search"
                          className="form-control"
                          placeholder="Search calls"
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1); // reset to first page on search
                          }}
                        /> */}
                      </div>
                    </li>
                  </ul>

                </div>





                <div className="table-responsive">
                  <table className="table table-hover" id="pc-dt-simple">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Call To</th>
                        <th>Connect Status</th>
                        <th>Duration (sec)</th>
                        <th>Called At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {calls?.length > 0 ? (
                        calls.map((call, index) => (
                          <tr key={call.id}>
                            <td>{index + 1 + (page - 1) * 10}</td>
                            <td>{call.callCustomer?.name || call.callUser?.username}</td>
                            <td>{call.call_to}</td>
                            <td>{call.connectStatus}</td>
                            <td>{call.durationSeconds}</td>
                            <td>
                              {new Date(call.calledAt).toLocaleString("en-GB", {
                                timeZone: "Africa/Dar_es_Salaam",
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit"
                              })}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-center" colSpan={6}>
                            <strong>No Calls Found.</strong>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                  <div className="text-muted">
                    Showing {(page - 1) * 10 + 1} to{' '}
                    {Math.min(page * 10, total)} of {total} entries
                  </div>
                  <Pagination
                    page={page}
                    pages={pages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllCallLog;
